(function ($) {
    class W4D_Dropdown {
        constructor() {
            this.initSelectors();
            this.bindEvents();
        }

        initSelectors() {
            this.$dropdowns = $('.dropdown');
            this.$dropdownTriggers = $('[data-js-dropdown-trigger]');
        }

        bindEvents() {
            // Handle standard dropdown triggers within dropdown containers
            this.$dropdowns.each((index, element) => {
                let $dropdown = $(element);
                let $toggleButton = $dropdown.find('[data-js-dropdown-trigger]');
                let $closeButton = $dropdown.find('[data-js-close]');

                $toggleButton.on('click', (e) => {
                    this.toggleDropdown(e, $dropdown, $toggleButton);
                });

                if ($closeButton.length) {
                    $closeButton.on('click', () => {
                        this.closeDropdown($dropdown, $toggleButton);
                    });
                }
            });

            this.bindExternalTriggers();

            $(document).on('click', (e) => this.closeAllDropdowns(e));
        }

        bindExternalTriggers() {
            // Find all triggers that are NOT inside a dropdown container
            this.$dropdownTriggers.not(this.$dropdowns.find('[data-js-dropdown-trigger]')).each((index, element) => {
                let $externalButton = $(element);
                let targetDropdownId = $externalButton.data('dropdown-target') || 'account-dropdown';
                let $targetDropdown = $(`#${targetDropdownId}`).closest('.dropdown');

                if ($targetDropdown.length) {
                    let $internalToggle = $targetDropdown.find('[data-js-dropdown-trigger]');

                    $externalButton.on('click', (e) => {
                        this.toggleDropdown(e, $targetDropdown, $internalToggle, $externalButton);
                    });
                }
            });
        }

        toggleDropdown(e, $dropdown, $toggleButton, $externalButton = null) {
            e.preventDefault();
            e.stopPropagation();

            if ($dropdown.hasClass('dropdown--open')) {
                this.closeDropdown($dropdown, $toggleButton);
            } else {
                this.closeAllDropdowns(e);
                this.showDropdown(e, $dropdown, $toggleButton);

                // Sync external trigger if provided
                if ($externalButton) {
                    $externalButton.attr('aria-expanded', 'true');

                    if ($externalButton.data('dropdown-target') === 'account-dropdown') {
                        $externalButton.html('<i class="icon-arrow-left mr-10"></i>Povratak');
                    }
                }
            }
        }

        showDropdown(e, $dropdown, $toggleButton) {
            $dropdown.addClass('dropdown--open');
            $toggleButton.attr('aria-expanded', 'true');
        }

        closeDropdown($dropdown, $toggleButton) {
            $dropdown.removeClass('dropdown--open');
            $toggleButton.attr('aria-expanded', 'false');

            this.syncExternalTriggers($dropdown, false);
        }

        closeAllDropdowns(e) {
            this.$dropdowns.each((index, element) => {
                let $dropdown = $(element);
                let $toggleButton = $dropdown.find('[data-js-dropdown-trigger]');

                if (!$dropdown[0].contains(e.target)) {
                    $dropdown.removeClass('dropdown--open dropdown--overlay');
                    $toggleButton.attr('aria-expanded', 'false');

                    this.syncExternalTriggers($dropdown, false);
                }
            });
        }

        syncExternalTriggers($dropdown, isOpen) {
            let dropdownId = $dropdown.find('[id]').first().attr('id');
            if (dropdownId) {
                let $externalTrigger = $(`[data-dropdown-target="${dropdownId}"]`);
                $externalTrigger.attr('aria-expanded', isOpen.toString());

                if (dropdownId === 'account-dropdown' && !isOpen) {
                    $externalTrigger.html('<i class="icon-account mr-10"></i>Moj račun');
                }
            }
        }
    }

    $(document).ready(() => new W4D_Dropdown());

})(jQuery);